import { h } from "preact";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
import FieldLabel from "./FieldLabel";
function SelectField(props) {
    var _a;
    const { controller, options, name, label, hideLabel = false, required = true, disabled = false, placeholder, dataFieldId, onChange, } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        controller.change(value);
        onChange && onChange();
    };
    const hasError = (controller.isTouched && controller.isInvalid) ||
        (controller.isTouched && required && !controller.value);
    return (h("div", { class: `select input form-group ${hasError ? "has-error" : ""}`, "data-field-id": dataFieldId },
        h(FieldLabel, { isRequired: required, isHidden: hideLabel, htmlFor: name }, label),
        h("div", { class: "m-select" },
            h("select", { class: "form-control m-select__select", name: name, id: name, value: (_a = controller.value) !== null && _a !== void 0 ? _a : undefined, onChange: handleChange, onBlur: () => controller.blur(), required: required, disabled: disabled },
                h(Option, { value: undefined, label: placeholder !== null && placeholder !== void 0 ? placeholder : "", selected: !controller.value, disabled: true, hidden: true, key: placeholder }),
                options.map((option) => {
                    return (h(Option, { value: option.value, label: option.label, key: option.value }));
                }))),
        hasError && h(FieldError, { errors: controller.errors })));
}
function Option(props) {
    const { value, label, disabled = false, selected = false, hidden } = props;
    return (h("option", { value: value, disabled: disabled, selected: selected, hidden: hidden, "data-option-id": value }, label));
}
export default observer(SelectField);
